import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'

export const routingClient = axios.create({
  baseURL: readFromEnv(Env.LogisticsRoutingServiceUrl),
})
